export function getCollisionType(tile) {
    switch (tile) {
        case 0: return 'Walkable Tile';
        case 1: return 'Solid Tile';
        case 2: return 'Collapsible Tile'; // Unused
        case 3: return 'Hole'; // Crate hole
        case 4: return 'Crate';
        case 5: return 'Collectable';
        case 6: return 'Hole (walkable)';
        case 7: return 'Level End';
        case 8: return 'Locked Door';
        case 9: return 'Key';
        case 10: return 'Ice';
        default: return 'Unknown';
    }

}